<script setup>
import { useCurrenciesStore } from '@/stores/currencies';
import { useCustomerStore } from '@/stores/customer';
import { closeModal } from '@kolirt/vue-modal'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

const currenciesStore = useCurrenciesStore();
const customerStore = useCustomerStore();
const router = useRouter();

const { t } = useI18n()

const props = defineProps({
	data: {
		type: Object,
		required: true
	}
})

const title = computed(() => {
	return t('general.bet_limit.bet_limit_exceeded')
})

const text = computed(() => {
	if (!props.data || !props.data.type) {
		return ''
	}

	const key = `general.bet_limit.${props.data.type}`
	const options = {
		stake: currenciesStore.format_currency(props.data.stake, customerStore.getCustomer.currency.code),
		limit: currenciesStore.format_currency(props.data.limit, customerStore.getCustomer.currency.code)
	}

	if (props.data.type === 'max_cumulative_stake_exceeded') {
		options.total_staked = props.data.total_staked

		const periodKey = `time_periods.${props.data.period}`
		options.period = t(periodKey)
	}

	return t(key, options)
})

const close = () => {
	try { closeModal(); } catch (e) {
		// do nothing
	}

	const currentPath = router.currentRoute.value?.path || ''
	if (currentPath.startsWith('/live-casino')) {
		router.push({ name: 'live-casino' })
	} else if (currentPath.startsWith('/casino')) {
		router.push({ name: 'casino' })
	} else {
		// Fallback to casino if context is unknown
		router.push({ name: 'casino' })
	}
}
</script>
<template>
	<div id="customModal" class="custom-modal-detail">
		<div class="modal-content">

			<span id="closeModalBtn" class="close">
				<svg xmlns="http://www.w3.org/2000/svg" width="13.414" height="13.414" viewBox="0 0 13.414 13.414" @click="closeModal()">
					<g id="close" transform="translate(0.707 0.707)">
						<line id="Line_2" data-name="Line 2" x2="12" y2="12" fill="none" stroke="#848484"
							stroke-linecap="round" stroke-width="1" />
						<line id="Line_3" data-name="Line 3" x1="12" y2="12" fill="none" stroke="#848484"
							stroke-linecap="round" stroke-width="1" />
					</g>
				</svg>
			</span>

			<div class="title">
				<p>{{ title }}</p>
			</div>

			<div class="content">
				<p>{{ text }}</p>
			</div>

			<div class="close-button" @click="close()">{{ $t('general.close') }}</div>

		</div>
	</div>
</template>
<style scoped>
.custom-modal-detail .modal-content {
	background-color: #0C131A;
	padding: 43px 0 35px;
	border-radius: 15px;
	border: 0.5px solid #d8d6d6;
	box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.7);
	text-align: center;
	position: relative;
	height: max-content;
	min-width: 300px;
	max-width: 450px;
	margin: 0 auto;
	transform: translateY(-50%);
	top: 50%;
}

.custom-modal-detail .modal-content .close {
	position: absolute;
	top: 20px;
	right: 20px;
	font-size: 20px;
	cursor: pointer;
}

[dir="rtl"] .custom-modal-detail .modal-content .close {
	right: auto;
	left: 20px;
}

.custom-modal-detail .modal-content .title {
	font-size: 20px;
	color: #F2F2F7;
	padding-bottom: 10px;
	font-weight: bold;
	margin-bottom: 10px;
}

.custom-modal-detail .modal-content .content {
	font-size: 14px;
	color: #F2F2F7;
	padding-bottom: 20px;
	margin-bottom: 10px;
	padding-left: 12px;
	padding-right: 12px;
}

.custom-modal-detail .modal-content .close-button {
	position: relative;
	border-radius: 5px;
	cursor: pointer;
	width: max-content;
	margin: 0 auto;
	padding: 10px 30px;
	font-size: 12px;
	font-weight: 600;
	text-transform: uppercase;
	background: #FFBB02;
	color: #202833;
	border: 1px solid transparent;
	transition: 0.3s ease-in-out;
}

.custom-modal-detail .modal-content .close-button:after {
	content: " ";
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: -1;
	margin: -1px;
	border-radius: inherit;
	background-image: linear-gradient(50deg, #e382bc 0%, #8d54eb 100%);
}
</style>